import TextField from "discourse/components/text-field";
import FormFieldBase from "./base";
import FormFieldWireFrame from "./wire-frame";

export default class FormFieldText extends FormFieldBase {
  <template>
    <FormFieldWireFrame
      @fieldName={{this.fieldName}}
      @title={{this.title}}
      @description={{this.description}}
      @required={{@required}}
      @maxLength={{@maxLength}}
      @validation={{@validation}}
      @value={{@value}}
    >
      <TextField
        autocomplete="off"
        class="circles-form-{{@name}} no-blur"
        ...attributes
        name={{this.fieldName}}
        @autofocus={{@autofocus}}
        @placeholder={{this.placeholder}}
        @value={{@value}}
        @onChange={{@onChange}}
      />
      {{yield}}
    </FormFieldWireFrame>
  </template>
}
